import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor() {}
}
